import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingInventory(props) {

  const [inventory, setInventory] = useState({
    fulfillment: "FBM",
    quantity: "",
    warehouse: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInventory({
      ...inventory,
      [name]: value
    });
  };

  return (

    <Container>

      <Row>

        {/* Page Title */}
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 8 : Inventory</h4>
        </Col>


        {/* Inventory Card */}

        <Col md={12}>

          <Card className="p-4">

            {/* Fulfillment Method */}

            <Row className="mb-3">

              <Col md={4} className="amazon-listing-labels">
                Fulfillment Method 
              </Col>

              <Col md={8}>

                <div className="d-flex">

                  <div className="mr-3">

                    <Input
                      type="radio"
                      name="fulfillment"
                      value="FBM"
                      checked={inventory.fulfillment === "FBM"}
                      onChange={handleChange}
                    />{" "}
                    Merchant Fulfilled (FBM)

                  </div>

                  <div className="ml-2">

                    <Input
                      type="radio"
                      name="fulfillment"
                      value="FBA"
                      checked={inventory.fulfillment === "FBA"}
                      onChange={handleChange}
                    />{" "}
                    Fulfilled by Amazon (FBA)

                  </div>

                </div>

              </Col>

            </Row>


            {/* Quantity */}

            <Row className="mb-3">

              <Col md={4} className="amazon-listing-labels">
                Quantity :
              </Col>

              <Col md={8}>

                <Input
                  type="number"
                  name="quantity"
                  // value={inventory.quantity}
                  // onChange={handleChange}
                  value="90"
                  placeholder="Enter quantity"
                />

              </Col>

            </Row>


            {/* Warehouse */}

            <Row className="mb-3">

              <Col md={4} className="amazon-listing-labels">
                Warehouse :
              </Col>

              <Col md={8}>

                <Input
                  type="text"
                  name="warehouse"
                  // value={inventory.warehouse}
                  // onChange={handleChange}
                  placeholder="Enter warehouse name"
                />

              </Col>

            </Row>

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingInventory;